import React, { useRef, useContext, useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react"; //useIsAuthenticated
import { TieredMenu } from "primereact/tieredmenu";
import { isTokenExpired, logout } from "../../../utils/msal-utils";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import AuthContext from "./authContext";
import "./headerSection.scss";
import {
  empProfileDetails,
  empProfile,
} from "../ProfileLanding/Profile/ProfileSlice";
//import NewFeatureAnnouncement from "../ProfileLanding/newFeatureAnnouncement";

import {
  getheaderfooters,
  getheaderfooter,
} from "../shared-components/getheaderfooterSlice";
import { useDispatch, useSelector } from "react-redux";
import jwt_decode from "jwt-decode";
import { HOME, MYMESSAGES } from "../../../utils/CONSTANTS";
import { Avatar } from "primereact/avatar";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { reportIssues } from "./reportIssueSlice";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { ScrollPanel } from "primereact/scrollpanel";
import { ProgressSpinner } from "primereact/progressspinner";
import NewFeatureAnnouncement from "../ProfileLanding/newFeatureAnnouncement";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBullhorn } from '@fortawesome/free-solid-svg-icons';

export default function HeaderSection({ announcements, fromHeader = true }) {
  //const [showPopup, setShowPopup] = useState(false);
  const announcementsArray = announcements
    ? Array.isArray(announcements)
      ? announcements
      : [announcements]
    : [];
  console.log("Header announcementsArray:", announcementsArray);

  // Filter out announcements dismissed via "Do not show again"
  const visibleAnnouncements = announcementsArray.filter(a => {
    const dismissed = JSON.parse(localStorage.getItem("dismissedAnnouncements") || "[]");
    return !dismissed.includes(a.title); // Use a unique id if you have one
  });
  const [showPopup, setShowPopup] = useState(false);
  console.log("Before render Header Section:", announcements);
  console.log("Show popup state:", showPopup);
  const { profileData } = useSelector(empProfileDetails);
  //const { announcements, showPopup } = props;
  //const { announcements, showPopup, setShowPopup } = props;
  //const [showNewFeature, setShowNewFeature] = useState(showPopup || false);
  //const [showNewFeature, setShowNewFeature] = useState(showPopup);
  // const { getheaderfooter} = useSelector(getheaderfooters);
  // const { reportIssue } = useSelector(postreportIssue);
  const userMenu = useRef(null);
  const { nonSSOlogout } = useContext(AuthContext);
  // const isAuthenticated = useIsAuthenticated();
  const accesstoken = localStorage.getItem("AccessToken-NonSSO");
  const ssotoken = localStorage.getItem("AccessToken");
  const { accounts, instance } = useMsal();
  const dispatch = useDispatch();
  const [userOG, setUserOG] = useState("");
  const [reportIssueVisible, setReportIssueVisible] = useState(false);
  const [submitIdeaVisible, setSubmitIdeaVisible] = useState(false);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  //const [showPopup, setShowPopup] = useState(false);
  //const [announcements, setAnnouncements] = useState([]); // fetched from API
  //const [showNewFeatureAnnouncement, setShowNewFeatureAnnouncement] = useState(false);
  //const [newFeatureAnnouncements, setNewFeatureAnnouncements] = useState([]);
  //const [showNewFeatureAnnouncement, setShowNewFeatureAnnouncement] = useState(false);
  // const [showNewFeatureAnnouncement, setShowNewFeatureAnnouncement] = useState(false);

  //const isLoggedIn = !!localStorage.getItem("token");



  let familyOG = "OG";
  const [oracleId, setOracleId] = useState("0");
  const role = localStorage.getItem("UserRole");
  const [issues, setIssues] = useState([]);
  const [selectedIssue, setSelectedIssue] = useState(null);
  const [description, setDescription] = useState("");
  const { getheaderfooterData } = useSelector(getheaderfooters);
  const [isSSOLogin, setIsSSOLogin] = useState(false);
  useEffect(() => {
    const SSOToken = localStorage.getItem("AccessToken");
    const nonSSOToken = localStorage.getItem("AccessToken-NonSSO");
    let id;
    console.log("HeaderSection props:", { announcements, showPopup });
    //if (SSOToken && isTokenExpired(SSOToken)) {
    //  console.log("SSO Token Expired");
    //  logout();
    //}
    if (nonSSOToken && isTokenExpired(nonSSOToken)) {
      // console.log("Non SSO Token Expired");
      nonSSOlogout();
    }

    if (SSOToken) {
      id = localStorage.getItem("oracleId");
      setIsSSOLogin(true);
    }
    if (nonSSOToken) {
      const decodedToken = jwt_decode(nonSSOToken);
      id = decodedToken?.oracleID;
    }
    setOracleId(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem("oracleId")]);



  /*const handleIconClick = () => {
    console.log("Icon clicked, setting popup to true");
    if (typeof setShowPopup === "function") {
      setShowPopup(true);
    }
  };
  const handleClosePopup = () => {
    console.log("Popup closed");
    setShowPopup(false);
  };*/

  console.log("Before render Header Section:", announcements);

  useEffect(() => {
    if (oracleId !== null && oracleId !== undefined && oracleId !== "0") {
      const requestdata = {
        // request: {
        action: "getEmpDetails",
        oracleId: oracleId,
        astt: "N",
        // },
      };
      dispatch(empProfile(requestdata));
    }
  }, [dispatch, oracleId]);

  const [socialLinks, setSocialLinks] = useState({
    facebook: "",
    twitter: "",
    linkedin: "",
    instagram: "",
    youtube: "",
  });
  let countryName = profileData?.automation?.employee?.location_country;
  let jobFamily = profileData?.automation?.employee?.job_family;

  useEffect(() => {
    if (
      oracleId !== null &&
      oracleId !== undefined &&
      oracleId !== "0" &&
      countryName !== null &&
      countryName !== undefined &&
      countryName !== "" &&
      jobFamily !== null &&
      jobFamily !== undefined &&
      jobFamily !== ""
    ) {
      const data = {
        action: "getResourceLinks",
        oracleId: oracleId,
        country: countryName,
        flag: "Header",
        jobFamily: jobFamily,
        is_sso: isSSOLogin,
      };
      dispatch(getheaderfooter(data));
    }
  }, [dispatch, oracleId, countryName, jobFamily, isSSOLogin]);

  useEffect(() => {
    if (getheaderfooterData) {
      // console.log("getheaderfooterData:", getheaderfooterData); // Log the value to the console

      // `resource` may be an array or object. Adjust accordingly.
      const links = Array.isArray(getheaderfooterData)
        ? getheaderfooterData
        : [getheaderfooterData];

      const updatedLinks = { ...socialLinks };

      links.forEach((item) => {
        const sub = item?.subfeature?.toLowerCase();
        if (item?.is_url === "Y" && item?.url && sub) {
          updatedLinks[sub] = item.url;
        }
      });

      setSocialLinks(updatedLinks);
    }
  }, [getheaderfooterData]);

  // console.log("getheaderfooterData" + getheaderfooterData);

  const userName = profileData?.oracle?.employee?.first_name
    ? profileData?.oracle?.employee?.first_name +
    " " +
    profileData?.oracle?.employee.last_name
    : "";

  const handleClose = () => {
    setSelectedIssue(null);
    setDescription("");
    setResponseMessage("");
    setErrorMessage("");
    setLoading(false);
    setReportIssueVisible(false);
    //setShowNewFeature(false);
    setShowPopup(false);
  };

  const handleSubmit = () => {
    if (!selectedIssue) {
      setErrorMessage("Please select an issue from the dropdown.");
      return;
    }

    if (!description || description.length < 20) {
      setErrorMessage("Description must be at least 20 characters long.");
      return;
    }

    if (oracleId !== null && oracleId !== undefined && oracleId !== "0") {
      setLoading(true); // Show loader
      const data = {
        oracleId: oracleId,
        shortDescription: selectedIssue.name,
        description: description,
      };

      dispatch(reportIssues(data)) // Dispatch the action
        .then((response) => {
          setLoading(false); // Hide loader
          if (response.payload.httpStatus === 200) {
            setResponseMessage(
              `Thank you for reaching out, we will address your concern as soon as possible. Here's your ticket number for your reference: ${response.payload.ticketNumber}`
            );
          } else {
            // Handle failure response based on role
            if (profileData?.automation?.employee?.job_family === "G&A") {
              setResponseMessage(
                "We are having issues creating the ticket, please open the ticket manually via ASKNow."
              );
            } else if (
              profileData?.automation?.employee?.job_family === "Agent"
            ) {
              setResponseMessage(
                `We are having issues creating the ticket, please reach out to your supervisor ${profileData?.oracle?.manager?.manager_first} {" "} ${profileData?.oracle?.manager?.manager_last}, so a ticket can be manually opened via ASKNow.`
              );
            }
          }
          setSelectedIssue(null);
          setDescription("");
        })
        .catch(() => {
          setLoading(false); // Hide loader if the request fails
          setErrorMessage("An error occurred while submitting the issue.");
        });
    }
  };

  const handleSubmitIdea = () => {
    if (!description || description.length < 20) {
      setErrorMessage("Description must be at least 20 characters long.");
      return;
    }

    const shortDescriptionText = "Idea Submission from " + userName;

    if (oracleId !== null && oracleId !== undefined && oracleId !== "0") {
      setLoading(true); // Show loader
      const data = {
        oracleId: oracleId,
        shortDescription: shortDescriptionText,
        description: description,
      };

      dispatch(reportIssues(data)) // Dispatch the action
        .then((response) => {
          setLoading(false); // Hide loader
          if (response.payload.httpStatus === 200) {
            setResponseMessage(
              "Thank you for reaching out, we will review your idea and implement as applicable."
            );
          } else {
            // Handle failure response based on role
            if (profileData?.automation?.employee?.job_family === "G&A") {
              setResponseMessage(
                "We are having issues submiting your idea, please open the ticket manually via ASKNow."
              );
            } else if (
              profileData?.automation?.employee?.job_family === "Agent"
            ) {
              setResponseMessage(
                `We are having issues submiting your idea, please reach out to your supervisor ${profileData?.oracle?.manager?.manager_first} {" "} ${profileData?.oracle?.manager?.manager_last}, so a ticket can be manually opened via ASKNow.`
              );
            }
          }
          setSelectedIssue(null);
          setDescription("");
        })
        .catch(() => {
          setLoading(false); // Hide loader if the request fails
          setErrorMessage("An error occurred while submitting the idea.");
        });
    }
  };

  const handleIdeaClose = () => {
    setSelectedIssue(null);
    setDescription("");
    setResponseMessage("");
    setErrorMessage("");
    setLoading(false);
    setSubmitIdeaVisible(false);
  };

  const errorDialog = (
    <Dialog
      header="Error"
      visible={errorDialogVisible}
      style={{ width: "30vw" }}
      onHide={() => setErrorDialogVisible(false)}
    >
      <div>{errorMessage}</div>
    </Dialog>
  );

  const footerContent = (
    <div>
      <Button
        label="Submit"
        onClick={handleSubmit}
        autoFocus
        disabled={
          !description.trim() || !description || description === "<p><br></p>"
        }
      />
    </div>
  );

  const footerContentIdea = (
    <div>
      <Button
        label="Submit"
        onClick={handleSubmitIdea}
        autoFocus
        disabled={
          !description.trim() || !description || description === "<p><br></p>"
        }
      />
    </div>
  );

  const filterDescription = (value) => {
    const arr = [
      "!",
      "#",
      "$",
      "%",
      "^",
      "&",
      "*",
      "(",
      ")",
      "-",
      "_",
      "+",
      "=",
      ";",
      ":",
      "'",
      '"',
      "<",
      ">",
      "/",
      "|",
      "\\",
      "{",
      "}",
      "[",
      "]",
      "~",
      "`",
    ];
    // Check if the value contains any special characters and remove them
    for (let i = 0; i < arr.length; i++) {
      if (value.includes(arr[i])) {
        value = value.replace(arr[i], "");
      }
    }
    setDescription(value);
  };

  const onPaste = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    if (profileData?.reportIssueResult?.Issue) {
      const transformedIssues = profileData.reportIssueResult.Issue.map(
        (issue) => ({
          name: issue.issue_type_name || "Unknown Issue",
          code: issue.issue_type_name || "Unknown Issue",
        })
      );
      setIssues(transformedIssues);
    }
  }, [profileData]);
  function handleLogout(instance, accounts) {
    confirmDialog({
      message: "Are you sure you want to Logout?",
      header: "Confirmation",
      icon: "pi pi-exclamation-circle",
      accept: () => {
        // Re-read at click time — component-scope values may be stale if a refresh
        // or re-auth ran between mount and click.
        const ssoNow    = localStorage.getItem("AccessToken");
        const nonSsoNow = localStorage.getItem("AccessToken-NonSSO");
        if (ssoNow) {
          logout();             // SSO path: hits PingOne /as/signoff via backend
        } else if (nonSsoNow) {
          nonSSOlogout();       // Non-SSO path: backend audit + local clear
        } else {
          // No tokens — just bounce to root.
          window.location.replace("/");
        }
      },
    });
  }

  const [myMessagesIcon, setMyMessagesIcon] = useState();
  useEffect(() => {
    if (
      profileData?.automation?.employee?.work_arrangement_type ===
      "Work At Home" &&
      profileData?.POD === "TRUE"
    ) {
      setMyMessagesIcon(true);
    }
  }, [profileData]);
  let userItems;

  myMessagesIcon === true
    ? (userItems = [
      { label: userName, icon: "pi pi-fw pi-user" },
      {
        separator: true,
      },
      {
        label: "My Messages",
        icon: "pi pi-comments",
        command: (e) => {
          window.location = "/messages";
        },
      },
      {
        separator: true,
      },
      {
        label: "Report a problem",
        icon: "pi pi-fw pi-flag",
        command: () => setReportIssueVisible(true),
      },
      {
        separator: true,
      },
      {
        label: "Submit an idea",
        icon: "pi pi-fw pi-comment",
        command: () => setSubmitIdeaVisible(true),
      },
      {
        separator: true,
      },
      {
        label: "Logout",
        icon: "pi pi-fw pi-power-off",
        command: () => handleLogout(instance, accounts),
      },
    ])
    : (userItems = [
      { label: userName, icon: "pi pi-fw pi-user" },
      /* {
  separator: true,
},
{
  label: "Profile",
  icon: "pi pi-users",
  command: (e) => {
    window.location = "/profile";
  },
}, */
      {
        separator: true,
      },
      {
        label: "Report a problem",
        icon: "pi pi-fw pi-flag",
        command: () => setReportIssueVisible(true),
      },
      {
        separator: true,
      },
      {
        label: "Submit an idea",
        icon: "pi pi-fw pi-comment",
        command: () => setSubmitIdeaVisible(true),
      },
      {
        separator: true,
      },
      {
        label: "Logout",
        icon: "pi pi-fw pi-power-off",
        command: () => handleLogout(instance, accounts),
      },
    ]);

  if (role === "") {
    userItems.splice(
      1,
      0,
      {
        separator: true,
      },
      {
        label: "Profile",
        icon: "pi pi-users",
        command: (e) => {
          window.location = "/profile";
        },
      }
    );
  }

  const userOGItems = [
    { label: userName, icon: "pi pi-fw pi-user" },
    {
      separator: true,
    },
    {
      label: "My Messsages",
      icon: "pi pi-comments",
      command: (e) => {
        window.location = "/messages";
      },
    },
    {
      separator: true,
    },
    {
      label: "Report a problem",
      icon: "pi pi-fw pi-flag",
      command: () => setReportIssueVisible(true),
    },
    {
      separator: true,
    },
    {
      label: "Submit an idea",
      icon: "pi pi-fw pi-comment",
      command: () => setSubmitIdeaVisible(true),
    },
    {
      separator: true,
    },
    {
      label: "Logout",
      icon: "pi pi-fw pi-power-off",
      command: () => handleLogout(instance, accounts),
    },
  ];

  useEffect(() => {
    const SSOToken = localStorage.getItem("AccessToken");
    let userRole = null;
    if (SSOToken) {
      userRole = localStorage.getItem("UserRole");
    }

    setUserOG(userRole);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem("oracleId")]);

  const [empImage, setEmpImage] = useState("./images/accountDefaultImage.png");
  //const [showNewFeature, setShowNewFeature] = useState(showPopup || false);


  useEffect(() => {
    setEmpImage(
      profileData?.image?.row?.image || "./images/accountDefaultImage.png"
    );
  }, [profileData?.image?.row?.image]);

  console.log("HeaderSection render debug:");
  // console.log("SSO token:", ssotoken);
  // console.log("Access token:", accesstoken);
  console.log("Announcements:", announcements);
  console.log("Announcements length:", announcements?.length);
  console.log("Show popup state:", showPopup);

  // Helper to check if the latest announcement is within 2 weeks
  function isWithinTwoWeeks(arr) {
    if (!arr || arr.length === 0) return false;
    const latest = arr.reduce((a, b) =>
      new Date(a.date) > new Date(b.date) ? a : b
    );
    const releaseDate = new Date(latest.date);
    const now = new Date();
    const diffDays = (now - releaseDate) / (1000 * 60 * 60 * 24);
    return diffDays <= 14;
  }

  const animateIcon = isWithinTwoWeeks(announcementsArray);
  console.log("Incoming announcements prop:", announcements);
  console.log("Announcements array:", announcementsArray);
  console.log("Within 2 weeks:", isWithinTwoWeeks(announcementsArray));
  return (
    <>
      <ConfirmDialog style={{ width: "100vw" }} />
      <header>
        <div className="px-3 bg-white text-ttecblue">
          <div className="container-fluid px-0 px-md-3 px-md-5 py-3 pe-0 pe-md-0">
            <div className="d-flex flex-wrap align-items-start justify-content-start justify-content-lg-start">
              <a
                href="https://www.ttec.com/"
                target="_blank"
                rel="noreferrer"
                className="my-2 my-lg-0 text-ttecblue text-decoration-none"
              >
                
              </a>

              <a
                href={role === "OG" ? MYMESSAGES : HOME}
                className="my-2 me-lg-auto"
                rel="noreferrer"
              >
                <img
                  src="./TTEC CONNECT_blueLogo.png"
                  className="img-fluid ms-4 pt-2"
                  alt=""
                  width={"180px"}
                />
              </a>

              <ul className="nav col-12 col-lg-auto my-2 justify-content-start justify-content-md-end my-md-0 text-small">
                {socialLinks.facebook && (
                  <li>
                    <a
                      href={socialLinks.facebook}
                      className="nav-link text-ttecblue px-0 me-2"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i
                        className="pi pi-facebook bi d-block mx-auto mb-1"
                        style={{ fontSize: "1.4em" }}
                      ></i>
                    </a>
                  </li>
                )}


                {socialLinks.twitter && (
                  <li>
                    <a
                      href={socialLinks.twitter}
                      className="nav-link text-ttecblue"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <svg
                        className="pi-x-twitter"
                        width="1200"
                        height="1227"
                        viewBox="0 0 1200 1227"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"
                          fill="#0495ff"
                        />
                      </svg>
                    </a>
                  </li>
                )}
                {socialLinks.linkedin && (
                  <li>
                    <a
                      href={socialLinks.linkedin}
                      className="nav-link text-ttecblue"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i
                        className="pi pi-linkedin bi d-block mx-auto mb-1"
                        style={{ fontSize: "1.4em" }}
                      ></i>
                    </a>
                  </li>
                )}
                {socialLinks.instagram && (
                  <li>
                    <a
                      href={socialLinks.instagram}
                      className="nav-link text-ttecblue"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i
                        className="pi pi-instagram bi d-block mx-auto mb-1"
                        style={{ fontSize: "1.4em" }}
                      ></i>
                    </a>
                  </li>
                )}
                {socialLinks.youtube && (
                  <li>
                    <a
                      href={socialLinks.youtube}
                      className="nav-link text-ttecblue me-2"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i
                        className="pi pi-youtube bi d-block mx-auto mb-1"
                        style={{ fontSize: "1.4em" }}
                      ></i>
                    </a>
                  </li>

                )}

                <li style={{ display: "flex", alignItems: "center", height: "36px" }}>
                  <span
                    className="nav-link text-ttecblue px-0 me-2"
                    title="Release Updates"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "36px",
                      width: "36px",
                      cursor: "pointer",
                      marginRight: "10px",
                      background: "transparent",
                      borderRadius: 0,
                      padding: 0,
                      position: "relative",
                    }}
                    onClick={() => setShowPopup(true)}
                  >
                    <FontAwesomeIcon
                      icon={faBullhorn}
                      className={isWithinTwoWeeks(announcementsArray) ? "animated-bullhorn" : ""}
                      style={{
                        fontSize: "1.4em",
                        color: "#007bff",
                        verticalAlign: "middle",
                        marginTop: "2px",
                      }}
                    />
                  </span>

                  {/* ✅ Header popup (no 'Do not show again') */}
                  {showPopup && (
                    <NewFeatureAnnouncement
                      announcements={announcementsArray} // show all announcements from API
                      fromHeader={true}                  // header context, disables checkbox
                      onClose={() => setShowPopup(false)}
                    />
                  )}
                </li>


                <li>
                  {(ssotoken || accesstoken) && userOG !== familyOG && (
                    <div>
                      <TieredMenu
                        model={userItems}
                        popup
                        ref={userMenu}
                        id="overlay_tmenu"
                        className="col-md-3 text-start"
                      />
                      <Avatar
                        image={empImage}
                        className="mr-2"
                        size="large"
                        shape="circle"
                        onClick={(event) => userMenu.current.toggle(event)}
                        aria-controls="popup_menu"
                        aria-haspopup
                        style={{ backgroundColor: "white" }}
                      />
                    </div>
                  )}

                  {(ssotoken || accesstoken) && userOG === familyOG && (
                    <div>
                      <TieredMenu
                        model={userOGItems}
                        popup
                        ref={userMenu}
                        id="overlay_tmenu"
                        className="col-md-3 text-start"
                      />
                      <Avatar
                        image={empImage}
                        className="mr-2"
                        size="large"
                        shape="circle"
                        onClick={(event) => userMenu.current.toggle(event)}
                        aria-controls="popup_menu"
                        aria-haspopup
                        style={{ backgroundColor: "white" }}
                      />
                    </div>
                  )}
                </li>
              </ul>
            </div>
          </div>
        </div>
        {errorDialog}
        <Dialog
          header="Report an Issue"
          visible={reportIssueVisible}
          style={{ width: "60vw" }}
          onHide={handleClose}
          footer={!responseMessage && footerContent} // Hide the footer when responseMessage exists
        >
          <ScrollPanel
            style={{ width: "auto", overflow: "auto", padding: "1rem" }}
          >
            <div>
              {!responseMessage ? (
                <>
                  <p>
                    <strong>User Details</strong>
                  </p>
                  <p>Employee Name: {userName}</p>
                  <p>
                    Employee Oracle ID:{" "}
                    {profileData?.oracle?.employee?.oracle_id}
                  </p>
                  <p>
                    <strong>
                      Issue Details <span style={{ color: "red" }}> *</span>
                    </strong>
                  </p>
                  <div className="card flex justify-content-center">
                    <Dropdown
                      value={selectedIssue}
                      onChange={(e) => setSelectedIssue(e.value)}
                      options={issues}
                      optionLabel="name"
                      placeholder="Select an Issue"
                      className="w-full md:w-14rem"
                    />
                  </div>

                  {selectedIssue && (
                    <>
                      <p>
                        <strong>
                          Issue Description{" "}
                          <span style={{ color: "red" }}> *</span>
                        </strong>
                      </p>
                      <div className="card flex justify-content-center">
                        <InputTextarea
                          autoResize
                          value={description}
                          onChange={(e) => filterDescription(e.target.value)}
                          onPaste={onPaste}
                          rows={5}
                          required
                          cols={30}
                        />
                      </div>
                      <small style={{ color: "gray", fontSize: "0.875rem" }}>
                        Minimum 20 characters required.
                      </small>
                    </>
                  )}

                  {loading && (
                    <div style={{ textAlign: "center", marginTop: "2rem" }}>
                      <ProgressSpinner
                        style={{ width: "50px", height: "50px" }}
                      />
                    </div>
                  )}

                  {errorMessage && !loading && (
                    <div style={{ color: "red", marginTop: "1rem" }}>
                      {errorMessage}
                    </div>
                  )}
                </>
              ) : (
                <div
                  style={{
                    marginTop: "1rem",
                    fontWeight: "bold",
                    color: "green",
                  }}
                >
                  {responseMessage}
                </div>
              )}
            </div>
          </ScrollPanel>
        </Dialog>
        <Dialog
          header="Submit an idea"
          visible={submitIdeaVisible}
          style={{ width: "60vw" }}
          onHide={handleIdeaClose}
          footer={!responseMessage && footerContentIdea} // Hide the footer when responseMessage exists
        >
          <ScrollPanel
            style={{ width: "auto", overflow: "auto", padding: "1rem" }}
          >
            <div>
              {!responseMessage ? (
                <>
                  <p>
                    <strong>User Details</strong>
                  </p>
                  <p>Employee Name: {userName}</p>
                  <p>
                    Employee Oracle ID:{" "}
                    {profileData?.oracle?.employee?.oracle_id}
                  </p>
                  <p>
                    <strong>Idea Details</strong>
                  </p>
                  <p>
                    <strong>
                      Please provide idea description
                      <span style={{ color: "red" }}> *</span>
                    </strong>
                  </p>
                  <div className="card flex justify-content-center">
                    <InputTextarea
                      autoResize
                      value={description}
                      onChange={(e) => filterDescription(e.target.value)}
                      onPaste={onPaste}
                      rows={5}
                      required
                      cols={30}
                    />
                  </div>
                  <small style={{ color: "gray", fontSize: "0.875rem" }}>
                    Minimum 20 characters required.
                  </small>

                  {loading && (
                    <div style={{ textAlign: "center", marginTop: "2rem" }}>
                      <ProgressSpinner
                        style={{ width: "50px", height: "50px" }}
                      />
                    </div>
                  )}

                  {errorMessage && !loading && (
                    <div style={{ color: "red", marginTop: "1rem" }}>
                      {errorMessage}
                    </div>
                  )}
                </>
              ) : (
                <div
                  style={{
                    marginTop: "1rem",
                    fontWeight: "bold",
                    color: "green",
                  }}
                >
                  {responseMessage}
                </div>
              )}
            </div>
          </ScrollPanel>
        </Dialog>





      </header>
    </>
  );
}
